// extracted by css-extract-rspack-plugin
export default {"cls1":"PreprintExportStep-cls1_WCs","cls2":"PreprintExportStep-cls2_dJw PreprintExportStep-cls1_WCs"};